import { IAppState } from '../../store';

export const selectUserAuthenticated = (state: IAppState) => state.user.isAuthenticated;
